import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "12",
            height: "12",
            x: "2",
            y: "10",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M6 18h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 14h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 6h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 9h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Dices";
const Dices = memo(themed(Icon));
export {
  Dices
};
//# sourceMappingURL=dices.js.map
